/**
 * AnalyticsHelper neutralizado para a build privada.
 * Mantém a interface pública (init/identify/track/page) como no-op,
 * para não quebrar os callers de useTrack().
 */
export class AnalyticsHelper {
  // eslint-disable-next-line no-empty-function, no-useless-constructor
  constructor() {}

  // eslint-disable-next-line class-methods-use-this, no-empty-function
  async init() {}

  // eslint-disable-next-line class-methods-use-this, no-empty-function
  identify() {}

  // eslint-disable-next-line class-methods-use-this, no-empty-function
  track() {}

  // eslint-disable-next-line class-methods-use-this, no-empty-function
  page() {}
}

export default new AnalyticsHelper();
